import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageType } from 'src/app/constants/const';
import { TypeIcon } from 'src/app/model/device/message.model';
import { IBBVAOpenTransactionData, BBVAOpenPageData, BBVATransactionData } from 'src/app/model/http/bbva.model';
import { BBVAPaymentsService } from 'src/app/services/bbvapayments.service';
import { CommonService } from 'src/app/services/common.service';
import { DialogService } from 'src/app/services/dialog.service';
import { BBVAOpenPageComponent } from '../bbvaopen-page/bbvaopen-page.component';
import { NotificationMessageComponent } from '../notification-message/notification-message.component';

@Component({
  selector: 'app-open-transactions-bbva',
  templateUrl: './open-transactions-bbva.component.html',
  styleUrls: ['./open-transactions-bbva.component.scss']
})
export class OpenTransactionsBBVAComponent implements OnInit {
  transaction: BBVAOpenPageData = new BBVAOpenPageData();
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Array<BBVAOpenPageData>,
    private matDialogRef: MatDialogRef<BBVAOpenPageComponent>,
    private dialogService: DialogService,
    private bbvaPaymentService: BBVAPaymentsService,
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.transaction = this.data[0];
  }

  cancel = () => {
    const successMessage = this.commonService.calculateTernary(this.data.length > 1,
      'Operaciones canceladas',
      'Operación cancelada');
    const failureMessage = this.commonService.calculateTernary(this.data.length > 1,
      'Error al cancelar las operaciones',
      'Error al cancelar la operación');
    const transactions: Array<string> = this.data.map(tr => (tr.default?.transactionId ?? ''));
    this.bbvaPaymentService.cancelTransactions(transactions).subscribe(res => {
      this.matDialogRef.close(true);
      this.showDialogMessage(
        false,
        successMessage,
        TypeIcon.success,
        MessageType.delete,
        false,
      );
    }, err => {
      this.showDialogMessage(
        false,
        failureMessage,
        TypeIcon.error,
        MessageType.delete,
        false,
      );
    });
  }

  showDialogMessage(
    isButtonCancel: boolean,
    textToShow: string,
    typeIcon: TypeIcon,
    typeMessage: MessageType,
    wasOk: boolean
  ): void {
    this.dialogService.openNotificationGeneric(NotificationMessageComponent, {
      isButtonCancel,
      textToShow,
      typeIcon,
      typeMessage,
      wasOk,
    });
  }


  continue = () => {
    const config = new MatDialogConfig();
    config.data = this.transaction;
    this.dialogService.displayDialog(BBVAOpenPageComponent, config);
  }
}
